/*
NOTES:
1. If the form is invalid then if not redirect url is specified SHopify redirects to /account/register, not this page!!!
2. If redirect_url is specified then no validation errors get displayed as it just redirects to that page so this is no use
3. Forced then to always redirect to this page as that's the only way we can handle validation issues
4. I was using "/discount/{{ section.settings.discount_code }}?redirect={{ section.settings.redirect_url }}" to apply the coupon then redirect to chosen page but now need to add the 
code as a cookie & display a confirmation page if the user is logged in on this page
5. As we need to add the subscription to the basket and prevent it happening multiple times, will store if this needs to be done by checking the cart when the page is loaded 
6. Capatcha could still cause issues as this could be displayed after the submit 

*/

document.addEventListener("DOMContentLoaded", () => {
  // Buttons
  const registerSubmitButton = document.getElementById('register_membership_submit_btn');

  // Forms
  const registerCustomerForm = document.getElementById('create_customer');

  const registerTagsField = document.getElementById('membership_registration_tags');

  // Documentation:  https://shopify.dev/docs/api/ajax/reference/cart
  // https://docs.rechargepayments.com/docs/add-an-item-to-the-cart-with-ajax-shop
  function addToCart(variantId, sellingPlanId) {
    let formData = {
      'items': [{
      'id': variantId,
      'quantity': 1,
      'selling_plan': sellingPlanId
      }]
    };
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      credentials: "same-origin",
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
      return response.json();
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }

  function setDiscountCookie (discount_code) {
    if(discount_code !== "") {
      document.cookie = `discount_code=${discount_code};path=/`;
    }
  }

  function addDiscountCodeToTags(discount_code) {
    if(discount_code !== "") {
      let tagsValue = registerTagsField.value + `,DISCOUNT-${discount_code}`;
      registerTagsField.value = tagsValue;
    }
  }

  // On Register Signup Click
  registerSubmitButton.addEventListener('click', (event) => {
    event.preventDefault();

    const subscriptionVariantId = registerSubmitButton.dataset.variantId;
    const subscriptionSellingPlanId = registerSubmitButton.dataset.sellingPlanId;
    const subscriptionProductAdded = registerSubmitButton.dataset.membershipProductAdded;
    const discountCode = registerSubmitButton.dataset.discountCode;

    setDiscountCookie(discountCode);

    addDiscountCodeToTags(discountCode);

    // Only add the membership product if it wasn't added already
    if(subscriptionProductAdded != 'true') {
      let response = addToCart(subscriptionVariantId, subscriptionSellingPlanId);
    }
    
    registerCustomerForm.submit();
  });

});    